import React, { useEffect, useState } from 'react';
import { IAccount } from '../../../Layout/Account/Data';
import MenuIcon from '../../../Layout/Menu/MenuIcon';
import Icons from '../../../../../components/Common/Icons/Icons';
import AccountDelivery from './Delivery';
import { Button } from '../../../../../components/Common/UI/Button';
import AccountNotify from './Notify';
import AccountAttachment from './Attachment';
import { cn } from '../../../../../utils/styles';
import InfoHint from '../Hint';

interface IAccountItem {
  account: IAccount;
  handleSave: (payload: IAccount) => void;
  handleEditMode: (ids: string[]) => void;
  handleChange: (payload: IAccount) => void;
  isEdit: boolean;
  editAll: boolean;
}

function AccountItem({ account, handleSave, handleEditMode, isEdit, handleChange, editAll }: IAccountItem) {
  const [initial, setInitial] = useState<IAccount>();
  const [hint, setHint] = useState<boolean>();

  const handleHint = (payload?: boolean) => {
    setHint(payload);
  };

  useEffect(() => {
    setInitial(account);
  }, [isEdit]);

  if (!initial) {
    return null;
  }

  const handleUpdate = (value: string, key: string) => {
    const newValue = key === 'attachment' ? value === 'yes' : value;

    handleChange({ ...account, [key as keyof IAccount]: newValue });
  };

  const handleCancel = () => {
    handleChange(initial);
    handleEditMode([account?.id]);
    setHint(false);
  };

  const handleEditClick = () => {
    handleEditMode([account?.id]);
  };

  const handleSubmit = () => {
    handleSave(account);
    setInitial(account);
    handleEditMode([account?.id]);
    setHint(true);
  };

  return (
    <div
      className="group rounded-lg border bg-addition6-3 px-[10px] py-[15px] grid gap-[20px] content-start
       relative"
    >
      <div className="flex gap-[5px] items-center justify-between">
        <div className="flex gap-[5px] items-center">
          <MenuIcon icon={<Icons.Account />} variant="white" className="border-0 opacity-50" size="large" />
          <div>
            <div className="font-medium text-[18px] leading-[20px]">{account.number}</div>
            <div className="text-[12px] opacity-50">{account.title}</div>
          </div>
        </div>
        <Button
          onClick={handleEditClick}
          className={cn('p-0 !bg-transparent invisible h-auto group-hover:visible', {
            visible: isEdit,
          })}
        >
          <MenuIcon icon={<Icons.EditPen />} className="border-0 opacity-80" size="large" />
        </Button>
      </div>
      {!isEdit && hint !== undefined ? <InfoHint visible={hint} handleHint={handleHint} /> : null}
      <div className="grid gap-[10px]">
        <AccountDelivery label="Delivery type" account={account} isEdit={isEdit} handleUpdate={handleUpdate} />
        <AccountNotify label="Notify me by" account={account} isEdit={isEdit} handleUpdate={handleUpdate} />
        <AccountAttachment label="Attachment" account={account} isEdit={isEdit} handleUpdate={handleUpdate} />
      </div>
      {isEdit && !editAll ? (
        <div className="flex gap-[10px] justify-end items-center">
          <Button onClick={handleCancel} className="p-[8px_10px] bg-addition10 hover:bg-addition10-80 min-w-[100px]">
            <Icons.PlusFilled className="rotate-45" />
            Cancel
          </Button>
          <Button onClick={handleSubmit} className="p-[8px_10px] bg-primary hover:bg-primary-80 min-w-[100px]">
            <Icons.Check />
            Save
          </Button>
        </div>
      ) : null}
    </div>
  );
}

export default AccountItem;
